'use strict';

var findTabbable = require('../helpers/tabbable');

module.exports = function (node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


//////////////////
// WEBPACK FOOTER
// ../~/react-modal-onfido/lib/helpers/scopeTab.js
// module id = 443
// module chunks = 1